import API_BASE from '../config';

/** Same default as backend/metering.py HUB_UPGRADE_URL. Hub SSO is the billing path. */
export const HUB_UPGRADE_URL = 'https://hub.solvit-ai.com/account';

const PLAN_NAMES = {
  greet: 'Greet',
  serve: 'Serve',
  concierge: 'Concierge',
  business: 'Business',
};

export function planDisplayName(plan) {
  const raw = String(plan || 'greet').trim().toLowerCase();
  const key = raw.startsWith('truva-') ? raw.slice(6) : raw;
  if (PLAN_NAMES[key]) return PLAN_NAMES[key];
  if (!key) return PLAN_NAMES.greet;
  return key.charAt(0).toUpperCase() + key.slice(1);
}

export function isFreePlan(plan) {
  const raw = String(plan || 'greet').trim().toLowerCase();
  const key = raw.startsWith('truva-') ? raw.slice(6) : raw;
  return key === 'greet' || key === 'free';
}

export function formatCents(cents) {
  const n = Number(cents);
  if (!Number.isFinite(n) || n <= 0) return '$0';
  const dollars = n / 100;
  return dollars % 1 === 0 ? `$${dollars.toFixed(0)}` : `$${dollars.toFixed(2)}`;
}

export function maxUsagePct(bal) {
  const minutes = Number(bal && bal.usage_pct_minutes) || 0;
  const sms = Number(bal && bal.usage_pct_sms) || 0;
  return Math.max(minutes, sms);
}

export async function fetchCreditBalance(authToken) {
  if (!authToken) return {};
  const res = await fetch(`${API_BASE}/api/credit/balance`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'ngrok-skip-browser-warning': 'true',
    },
  });
  const data = res.ok ? await res.json().catch(() => ({})) : {};
  return data && typeof data === 'object' ? data : {};
}

async function postCredit(authToken, path, payload) {
  if (!authToken) return { ok: false, status: null };
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'ngrok-skip-browser-warning': 'true',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload || {}),
  });
  const data = await res.json().catch(() => ({}));
  return { ...(data && typeof data === 'object' ? data : {}), status: res.status };
}

/** Starts a prepaid top-up; resolves {ok, url} (Hub-hosted Stripe Checkout) or {ok:false, error}. */
export function startTopup(authToken) {
  return postCredit(authToken, '/api/credit/topup');
}

/** Opt in/out of overage billing with an optional spend limit (cents; null = no limit). */
export function setOverage(authToken, enabled, limitCents) {
  return postCredit(authToken, '/api/credit/overage', {
    enabled: !!enabled,
    limit_cents: limitCents == null ? null : Number(limitCents),
  });
}
